import React, { useState, useRef } from 'react'
import { useStateValue } from '@State'

export const CertAward = ({ disable }) => {
  const [state, dispatch] = useStateValue()
  const [editAward, setEditAward] = useState(false)
  const awardInput = useRef(null)

  const handleChange = () => {
    dispatch({
      type: 'UPDATE_CERT_INFO',
      payload: { award: awardInput.current.value },
    })
    setEditAward(false)
  }

  if (editAward) {
    return (
      <div
        className={disable ? 'text-center' : 'text-center input_element'}
        id="award"
      >
        <input
          type="text"
          id="award_input"
          ref={awardInput}
          defaultValue={state.certInfo.award}
          onBlur={handleChange}
        />
      </div>
    )
  }

  return (
    <div className="text-center input_element" id="award">
      {state.certInfo.award}
      <div
        className={disable ? '' : 'icon icon_pencil'}
        id="award_pencil"
        onClick={() => setEditAward(true)}
      />
    </div>
  )
}
